import { Outlet } from 'react-router-dom'
import logo from 'assets/img/krish.svg'

const LogoLayout = () => {
  console.log('----------------')
  return (
    <>
      <header className="flex h-16 items-center justify-end px-10 py-3">
        <div className="w-28 shrink-0">
          <img
            src={logo}
            alt="gag-logo"
            className="h-full w-full object-contain"
          />
        </div>
      </header>
      <main>
        <Outlet />
      </main>
    </>
  )
}

export default LogoLayout
